import { ApplicationRef, enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { enableDebugTools } from '@angular/platform-browser';
import { installBrowserExtensionErrorGuard } from './browser-extension-error-guard';

// USED FOR AOT
import 'lscache';
// import 'lodash';

// import { enableDebugTools } from '@angular/platform-browser';
// import { ApplicationRef } from '@angular/core';
if (environment.production) {
  enableProdMode();
}

// Silence noise from browser-extension content scripts (e.g. "Could not establish
// connection. Receiving end does not exist."). Scoped to exact extension signatures;
// real application errors are left untouched. Registered before bootstrap.
installBrowserExtensionErrorGuard();

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [ provideZoneChangeDetection() ] }).then(moduleRef => {
  const appRef = moduleRef.injector.get(ApplicationRef);
  const cmpRef = appRef.components[0];
  enableDebugTools(cmpRef);
}).catch(err => console.error(err));
